// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"CommandBar_loadingContainer__Ho4AK"};